import { P as f, b as c, n as o, t as h } from "./element-CV9utnHJ.js";
import { e as k, n as m } from "./ref-Dma3n3i8.js";
import { P as d } from "./pkt-slot-controller-D7CrjM52.js";
import "./icon-D0IQAVwS.js";
import { o as u } from "./if-defined-rXcLNTzN.js";
var _ = Object.defineProperty, y = Object.getOwnPropertyDescriptor, r = (n, i, s, l) => {
  for (var e = l > 1 ? void 0 : l ? y(i, s) : i, a = n.length - 1, p; a >= 0; a--)
    (p = n[a]) && (e = (l ? p(i, s, e) : p(e)) || e);
  return l && e && _(i, s, e), e;
};
let t = class extends f {
  constructor() {
    super(), this.defaultSlot = k(), this.title = "", this.href = "#", this.iconName = "", this.external = !1, this.openInNewTab = !1, this.skin = "normal", this.slotController = new d(this, this.defaultSlot);
  }
  render() {
    const n = ["pkt-linkcard", this.skin && `pkt-linkcard--${this.skin}`].filter(Boolean).join(" "), i = ["pkt-linkcard__title", this.external && "pkt-link pkt-link--external"].filter(Boolean).join(" ");
    return c`
      <a
        href=${this.href}
        class=${n}
        target=${this.openInNewTab ? "_blank" : "_self"}
        rel=${u(this.openInNewTab ? "noopener noreferrer" : void 0)}
      >
        ${this.iconName && c`<pkt-icon class="pkt-link__icon" name="${this.iconName}" />`}
        ${this.title && c`<div class=${i}>${this.title}</div>`}

        <div class="pkt-linkcard__text" ${m(this.defaultSlot)}></div>
      </a>
    `;
  }
};
r([
  o({ type: String, reflect: !0 })
], t.prototype, "title", 2);
r([
  o({ type: String, reflect: !0 })
], t.prototype, "href", 2);
r([
  o({ type: String, reflect: !0 })
], t.prototype, "iconName", 2);
r([
  o({ type: Boolean, reflect: !0 })
], t.prototype, "external", 2);
r([
  o({ type: Boolean, reflect: !0 })
], t.prototype, "openInNewTab", 2);
r([
  o({ type: String, reflect: !0 })
], t.prototype, "skin", 2);
t = r([
  h("pkt-linkcard")
], t);
export {
  t as P
};
